// extracted by mini-css-extract-plugin
module.exports = {"section":"_e483891","header":"_4ad731f","gameImage":"_79e9f3c","title":"_4172043","titleTextSize":"_4d42a7b","container":"_045bb89","buttons":"_4f09e4a","image":"_12f25c7"};